<template>
  <div class="bargain-item mt-3">
    <v-text-field
      v-model="bargainID"
      label="Fyra siffror endast 1 - 6."
      maxlength="4"
      outlined
      type="tel"
      class="mb-0 pb-0"
    ></v-text-field>

    <v-switch
      v-model="enhancedLuck"
      :label="`${enhancedLuck ? searchMessage[1] : searchMessage[0] }`"
      color="white"
      :class="{'black--text': enhancedLuck }"
      class="mt-n6 ma-0 pa-0 caption"
      dense
      hint="Aktivera för bättre chans till att hitta en Artefakt om rollpersonen är en Zonstrykare eller har någon annan bonus."
      persistent-hint
    ></v-switch>

    <v-alert
      border="top"
      colored-border
      color="#ffc700"
      elevation="2"
      transition="slide-y-transition"
      :value="hasErrors"
    >
      {{ errorMessage }}
    </v-alert>
    <item-card v-show="validate" v-bind:item="item" :isArtefact="isArtefact" />
  </div>
</template>

<script>
import ItemCard from './ItemCard'

export default {
  components: {ItemCard},
  name: 'BargainItem',
  data () {
    return {
      bargainID: '',
      hasErrors: false,
      errorMessage: "",
      item: {},
      enhancedLuck: false,
      searchMessage: [
        "Zonstrykare, aktivera sökbonus!",
        "Sökbonus aktiverad!"
      ],
      isArtefact: false,
    }
  },
  computed: {
    validate() {
      let values = this.bargainID.split("")
      let isValid = false
      let numbersFailed = 0
      this.clearErrors()

      for (let i = 0; i < values.length; i++) {
        if (this.validateInput(values[i])) {
          numbersFailed++
        }
      }

      if (numbersFailed === 0 && this.bargainID.length === 4) {
        isValid = true
        this.submit()
      }

      return isValid
    }
  },
  methods: {
    base6ToBase10(bargainID) {
      // base6 is 0 - 5 so convert input to that
      let id = parseInt(bargainID) - 1111
      id = parseInt(id, 6)

      // Our database id starts at 1
      id += 1

      return id
    },
    clearErrors() {
      this.errorMessage = ""
      this.hasErrors = false
    },
    getItemById(id) {
      const url = "https://mutantapi.fickla.nu/api/items/"
      fetch(url + id)
      .then(response => response.json())
      .then(json => {
          this.item = json
        }
      )
    },
    getLuckyItem() {
      const url = "https://mutantapi.fickla.nu/api/lucky-item"
      fetch(url)
      .then(response => response.json())
      .then(json => {
          this.item = json
        }
      )
    },
    luckyRoll() {
      let lucky = false
      this.isArtefact = false
      const roll = Math.floor(Math.random() * 100)
      let playerLuckChance = 3

      if (this.enhancedLuck) playerLuckChance = 15

      if (roll < playerLuckChance) {
        this.isArtefact = true
        lucky = true
      }

      return lucky
    },
    validateInput(input) {
      let errors = false
      let parsed = parseInt(input)

      if (!isNaN(parsed)) {
        if (input > 6) {
          this.errorMessage = '1-6, hur svårt kan det vara ...?'
          this.hasErrors = true
          errors = true
        }
        else if (input < 1) {
          this.errorMessage = 'Du verkar vara en riktig nolla!'
          this.hasErrors = true
          errors = true
        }
      }
      else {
        this.hasErrors = true
        errors = true
        this.errorMessage = "Nu finns det ju bara siffror på en tärning!"
      }

      return errors
    },
    submit() {
      const hasLuck = this.luckyRoll()
      this.item = {}

      if (hasLuck) {
        this.getLuckyItem()
      }
      else {
        const id = this.base6ToBase10(this.bargainID)
        this.getItemById(id)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.theme--dark {
  .bargain-item {
    #bargain_submit {
      color: rgb(255,199,0);
      background-color: #222;
      font-weight: bold;

      &.v-btn--disabled {
        background-color: rgba(0, 0, 0, .4) !important;
        color: rgba(255,199,0,0.4) !important;
      }
    }

    .v-label {
      color: rgba(255, 255, 255, 0.5);
    }
    .v-label {
      font-size: 1.2rem;

      &--active.primary--text {
        color: rgb(255,199,0) !important;
      }
    }
    fieldset {
      border-color: rgb(255,199,0) !important;
      color: rgb(255,199,0) !important;
    }
    .v-input__slot {
      background: rgba(0,0,0,.8) !important;
    }
    .black--text.v-input--switch .v-input__slot .v-label {
      color:#FFF;
    }
    .v-input--switch .v-input__slot {
      background: none !important;
    }
    .v-input--switch .v-label {
      font-size: 1rem;
    }

    input {
      caret-color: rgb(255,199,0) !important;
      font-size: 1.5rem;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
